/**
 * DesignSystemPage — top-level super-admin page (sidebar entry).
 * Wraps DesignSystemPanel with the standard MainLayout chrome so it has
 * sidebar + page header + the same look as Tenants / Users / etc.
 */

import { Sidebar } from '@/components/layout/Sidebar';
import DesignSystemPanel from './DesignSystemPanel';
import './components/component-demo.css';

export default function DesignSystemPage() {
  return (
    <div className="admin-container">
      <Sidebar />
      <div className="main-container">
        {/* main-content keeps the global overflow:hidden — DesignSystemPanel
            owns its own scroll surface(s) so the page-level scrollbar
            never runs behind the sticky header (it sits BESIDE the content
            below the title instead of crossing it). */}
        <main className="main-content">
          <DesignSystemPanel />
        </main>
      </div>
    </div>
  );
}
